import { enqueueSnackbar } from 'notistack';

import { TaskCardSecondaryCta } from '../common/TaskCardShell/TaskCardShell';
import { Task } from '../types';

import useConfirmCompensationSalary from 'services/payroll/mutations/useConfirmCompensationSalary';

const REVIEW_REASONABLE_COMPENSATION = 'review_reasonable_compensation';

export const KEPT_SALARY_MESSAGE =
    'Your salary stays the same. To change it later, go to Payroll > My compensation and select Update.';

/**
 * "Leave it unchanged" on the review-compensation task. Offered only when the backend says the
 * member has a chosen salary to keep; one who never set one only gets the wizard. Keeping it
 * completes the task server-side, and the mutation refreshes the task lists.
 */
export default function useKeepCurrentSalaryCta(task: Task): TaskCardSecondaryCta | null {
    const { mutate: confirmSalary, isPending } = useConfirmCompensationSalary();

    if (task.task_template.name !== REVIEW_REASONABLE_COMPENSATION || task.context.can_keep_current_salary !== true) {
        return null;
    }

    return {
        label: 'Leave it unchanged',
        disabled: isPending,
        onClick: () =>
            confirmSalary(undefined, {
                onSuccess: () => enqueueSnackbar(KEPT_SALARY_MESSAGE, { variant: 'info', autoHideDuration: 10000 }),
            }),
    };
}
